
if(typeof $=='undefined'){
    $ = jQuery = require('jquery');
}

function deleteAllCookies() {
    document.cookie.split(";").forEach(function(c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); });

    return ;
}
$(function () {
    $('.cookie-consent').each(function () {
        const wrapper = $(this);
        let loading = false;

        wrapper.addClass('hidden');
        setTimeout(function () {
            wrapper.removeClass('hidden');
        }, 5000);



        wrapper.find('.cookie-consent-reject').click(function () {
            deleteAllCookies();
            const link = $(this);
            let normalLabel = link.html();

            if (!loading) {
                loading = true;
                link.html(link.data('loading-text'));

                $.ajax({
                    url: this.href,
                    success: function () {
                        link.css('visibility', 'hidden');
                        wrapper.animate({ 'opacity': 0, 'margin-top': -wrapper.height() }, 'fast', function () {
                            wrapper.remove();
                        });
                    },
                    complete: function () {
                        loading = false;
                        link.html(normalLabel);
                    }
                });
            }
            return false;
        });

        wrapper.find('.cookie-consent-trigger').click(function () {
            //return false; // disable ajax
            const link = $(this);
            let normalLabel = link.html();

            if (!loading) {
                loading = true;
                link.html(link.data('loading-text'));

                $.ajax({
                    url: this.href,
                    success: function () {
                        link.css('visibility', 'hidden');
                        wrapper.animate({ 'opacity': 0, 'margin-top': -wrapper.height() }, 'fast', function () {
                            wrapper.remove();
                        });
                    },
                    complete: function () {
                        loading = false;
                        link.html(normalLabel);
                    }
                });
            }

            return false;
        });



    });
});